import { Anchor, Span } from '@dnb/eufemia';
import { Link } from 'react-router-dom';

import { NavNode } from '../../utils';
import TypeBadge from './TypeBadge';

interface Props {
  navNode: NavNode;
  hideTooltip?: boolean;
}

export function NavigationItem({ navNode, hideTooltip }: Props) {
  const getTooltipText = () => {
    const typeSuffix: Record<string, string> = {
      'api-doc': 'Documentation',
      'event-doc': 'Documentation',
      'event-mgmt': 'Management',
      'api-mgmt': 'Management',
      'api-ccr': 'Common Contract Repository',
    };

    const suffix = typeSuffix[navNode.type];
    return suffix ? `${navNode.name} - ${suffix}` : navNode.name;
  };

  return (
    <Anchor
      className="flex items-center gap-1 max-w-[10rem] h-6"
      element={Link}
      noUnderline
      to={navNode.path}
      tooltip={hideTooltip ? null : getTooltipText()}
    >
      <TypeBadge size="medium" type={navNode.type} />
      <Span className="overflow-hidden text-ellipsis whitespace-nowrap" size="small">
        {navNode.name}
      </Span>
    </Anchor>
  );
}
